import React from 'react';
import { IndexRoute, Route } from 'react-router';

import {
  LoadableEventReviewPageSuccess,
  LoadableEventReviewPageFormWrapper,
  LoadableEventReviewPage,
  LoadableEventTicketsPage,
  LoadableCharityEntryPage,
  LoadableEventDetailPage,
  LoadableSubmissionRouter,
  LoadableBibCollectionPage,
  LoadableAddEventPage,
} from './helpers/loadables';

// These components loadable code is nested below their redux fetch layer.
import { submissionPages } from '../../views/VirtualEvent/layout/SubmissionRouter/constants';

import { getHandleRedirect } from './helpers/eventUrl';

const prefixes = [
  '/e/(:eventSlug-):eventId',
  '/:localeSlug/e/(:eventSlug-):eventId',
];

const getEventRoutes = (authService) => {
  const createSubmissionPageRoute = (
    pathSuffix,
    submissionPage,
    mustBeLoggedin,
    mustBeAdmin,
  ) => ({
    component: LoadableSubmissionRouter,
    pathSuffix,
    submissionPage,
    onEnter:
      mustBeLoggedin &&
      (mustBeAdmin ? authService.adminRoute : authService.authenticateRoute),
  });

  const eventPageRoutesConfig = [
    // TODO: replace with new EventDetailPage component @dion
    {
      pathSuffix: '',
      component: LoadableEventDetailPage,
    },
    createSubmissionPageRoute('/results', submissionPages.RESULTS),
    createSubmissionPageRoute(
      '/results/deepdive',
      submissionPages.RESULTS_DEEPDIVE,
    ),
    createSubmissionPageRoute(
      // Will be discontinued, leaving for a couple of weeks
      '/result-confirmation/:resultSubmissionId',
      submissionPages.RESULT,
    ),
    createSubmissionPageRoute(
      '/result/:resultSubmissionId',
      submissionPages.RESULT,
    ),
    createSubmissionPageRoute(
      '/result/booking/:fullBookingId',
      submissionPages.RESULT,
    ),
    createSubmissionPageRoute(
      '/result-submissions',
      submissionPages.SUBMISSIONS,
      true,
    ),
    createSubmissionPageRoute(
      '/result-submissions/:fullBookingId',
      submissionPages.SUBMISSION_GROUP,
      true,
    ),
    createSubmissionPageRoute('/submit-result', submissionPages.SUBMIT),
    createSubmissionPageRoute(
      '/submit-result/booking/:fullBookingId',
      submissionPages.BOOKING_SUBMIT,
    ),
    createSubmissionPageRoute(
      '/submit-result/booking/:fullBookingId/admin',
      submissionPages.BOOKING_SUBMIT_ADMIN,
      true,
      true,
    ),
    createSubmissionPageRoute(
      '/submit-result/booking/:fullBookingId/admin/:step',
      submissionPages.BOOKING_SUBMIT_ADMIN,
      true,
      true,
    ),
    {
      pathSuffix: '/collect-bib',
      component: LoadableBibCollectionPage,
    },
    {
      pathSuffix: '/collect-bib/:raceId',
      component: LoadableBibCollectionPage,
    },
    {
      pathSuffix: '/collect-bib/:raceId/eoReference/:eoReference',
      component: LoadableBibCollectionPage,
    },
    {
      pathSuffix: '/collect-bib/:raceId/eoReference/:eoReference/step/:step',
      component: LoadableBibCollectionPage,
    },
    createSubmissionPageRoute(
      '/submit-result/booking/:fullBookingId/:step',
      submissionPages.BOOKING_SUBMIT,
    ),
    createSubmissionPageRoute(
      '/result/:resultSubmissionId/edit',
      submissionPages.EDIT_SUBMISSION,
      true,
    ),
    createSubmissionPageRoute(
      '/result/:resultSubmissionId/edit/admin',
      submissionPages.EDIT_SUBMISSION_ADMIN,
      true,
      true,
    ),
    createSubmissionPageRoute(
      '/result/:resultSubmissionId/edit/admin/:step',
      submissionPages.EDIT_SUBMISSION_ADMIN,
      true,
      true,
    ),
    createSubmissionPageRoute(
      '/result/:resultSubmissionId/edit/:step',
      submissionPages.EDIT_SUBMISSION,
      true,
    ),
    createSubmissionPageRoute(
      '/result/booking/:fullBookingId/edit',
      submissionPages.EDIT_SUBMISSION,
    ),
    createSubmissionPageRoute(
      '/result/booking/:fullBookingId/edit/admin',
      submissionPages.EDIT_SUBMISSION_ADMIN,
      true,
      true,
    ),
    createSubmissionPageRoute(
      '/result/booking/:fullBookingId/edit/admin/:step',
      submissionPages.EDIT_SUBMISSION_ADMIN,
      true,
      true,
    ),
    createSubmissionPageRoute(
      '/result/booking/:fullBookingId/edit/:step',
      submissionPages.EDIT_SUBMISSION,
    ),
  ].reduce((arr, { pathSuffix, ...props }) => {
    const paths = prefixes.map((prefix) => `${prefix}${pathSuffix}`);
    paths.forEach((path) => arr.push({ path, ...props }));
    return arr;
  }, []);

  const handleRedirect = getHandleRedirect();

  return (
    <>
      {eventPageRoutesConfig.map(({ path, ...props }) => {
        return (
          <Route
            key={path}
            path={path}
            noFooter
            whiteBackground
            onEnter={handleRedirect}
            {...props}
          />
        );
      })}
      {/* Reviews pages, first with country specificity and the second without */}
      <Route
        path="/:localeSlug/e/(:eventSlug-):eventId/review"
        component={LoadableEventReviewPage}
        whiteBackground
        onEnter={handleRedirect}
        canUsePartnerTheme
      >
        <IndexRoute
          component={LoadableEventReviewPageFormWrapper}
          whiteBackground
          canUsePartnerTheme
        />
        <Route
          path="success"
          component={LoadableEventReviewPageSuccess}
          whiteBackground
          canUsePartnerTheme
        />
      </Route>
      <Route
        path="/e/(:eventSlug-):eventId/review"
        component={LoadableEventReviewPage}
        onEnter={handleRedirect}
        whiteBackground
        canUsePartnerTheme
      >
        <IndexRoute
          component={LoadableEventReviewPageFormWrapper}
          whiteBackground
          canUsePartnerTheme
        />

        <Route
          path="success"
          component={LoadableEventReviewPageSuccess}
          whiteBackground
          canUsePartnerTheme
        />
      </Route>
      {/* Non country specific links */}
      <Route
        path="/e/(:eventSlug-):eventId/tickets(/:raceId)"
        component={LoadableEventTicketsPage}
        onEnter={handleRedirect}
        whiteBackground
        canUsePartnerTheme
      />
      {/* Country specific links */}
      <Route
        path="/:localeSlug/e/(:eventSlug-):eventId/tickets(/:raceId)"
        component={LoadableEventTicketsPage}
        onEnter={handleRedirect}
        whiteBackground
        canUsePartnerTheme
      />
      {/* Charity pages */}
      {/* Non country specific links */}
      <Route
        path="/e/(:eventSlug-):eventId/charity-entry(/:raceId)"
        component={LoadableEventTicketsPage}
        onEnter={handleRedirect}
        whiteBackground
        canUsePartnerTheme
      />
      {/* Country specific links */}
      <Route
        path="/:localeSlug/e/(:eventSlug-):eventId/charity-entry(/:raceId)"
        component={LoadableCharityEntryPage}
        onEnter={handleRedirect}
        whiteBackground
        canUsePartnerTheme
      />
      {/* Add Event to Profile -- requires log in locale specific */}
      <Route
        path="/:localeSlug/e/:eventId/add-event"
        component={LoadableAddEventPage}
        onEnter={authService.authenticateRoute}
        whiteBackground
      />
      {/* Add Event to Profile -- requires log not locale specific */}
      <Route
        path="/e/:eventId/add-event"
        component={LoadableAddEventPage}
        onEnter={authService.authenticateRoute}
        whiteBackground
      />
    </>
  );
};

export default getEventRoutes;
